import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, MoreVertical } from "lucide-react";
import type { UpcomingAppointment } from "@/services/api/dashboard";
import { SectionHeader } from "./SectionHeader";
import { StatusPill } from "./StatusPill";

type UpcomingAppointmentsProps = {
  appointments: UpcomingAppointment[];
};

export function UpcomingAppointments({
  appointments,
}: UpcomingAppointmentsProps) {
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
      <SectionHeader title="Upcoming Appointments">
        <Link
          to="/calendar"
          className="inline-flex items-center gap-2 text-sm font-bold text-blue-600"
        >
          View Calendar
          <ArrowRight size={17} />
        </Link>
      </SectionHeader>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[680px] border-collapse">
          <thead>
            <tr className="text-left text-xs font-bold text-slate-500">
              <th className="py-2 pr-3">Name</th>
              <th className="px-3 py-2">Date & Time</th>
              <th className="px-3 py-2">AI-Agent</th>
              <th className="px-3 py-2">Type</th>
              <th className="px-3 py-2">Status</th>
              {/* <th className="py-2 pl-3" aria-label="Actions" /> */}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 text-xs font-semibold text-slate-700">
            {appointments.length === 0 && (
              <tr>
                <td
                  colSpan={6}
                  className="h-[120px] text-center text-sm font-semibold text-slate-500"
                >
                  No upcoming appointments.
                </td>
              </tr>
            )}

            {appointments.map((item, index) => (
              <tr key={item.appointmentId}>
                <td className="whitespace-nowrap py-2 pr-3">
                  <div className="flex items-center gap-2">
                    <span
                      className={`flex h-7 w-7 items-center justify-center rounded-full text-[11px] font-bold ${
                        index % 4 === 0
                          ? "bg-cyan-100 text-cyan-700"
                          : index % 4 === 1
                            ? "bg-blue-100 text-blue-700"
                            : index % 4 === 2
                              ? "bg-indigo-100 text-indigo-700"
                              : "bg-amber-100 text-amber-700"
                      }`}
                    >
                      {item.customerInitials}
                    </span>
                    {item.customerName}
                  </div>
                </td>
                <td className="whitespace-nowrap px-3 py-2">
                  <CalendarDays
                    className="mr-2 inline-block text-slate-500"
                    size={15}
                  />
                  {item.scheduledDateTimeLabel}
                </td>
                <td className="whitespace-nowrap px-3 py-2">
                  {item.assignedAgentName}
                </td>
                <td className="whitespace-nowrap px-3 py-2">
                  {item.appointmentType}
                </td>
                <td className="whitespace-nowrap px-3 py-2">
                  <StatusPill status={item.statusLabel} />
                </td>
                {/* <td className="whitespace-nowrap py-2 pl-3 text-right">
                  <button
                    type="button"
                    aria-label={`More actions for ${item.customerName}`}
                    className="inline-flex h-8 w-8 items-center justify-center rounded-md text-slate-500 hover:bg-slate-100"
                  >
                    <MoreVertical size={16} />
                  </button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
